import { ReactNode } from 'react';

import { SharedProps } from '../../types';
import Container from '../../UI/Container';
import Layout from '../../UI/Layout';
import EditProjectForm, { EditProjectFormProps } from './EditProjectForm';
import { ProjectLayout } from './ProjectLayout';

export interface EditProjectPageProps extends SharedProps {
  project: EditProjectFormProps['project'];
  users: EditProjectFormProps['users'];
}

export default function EditProjectPage({
  project,
  users,
  charity,
}: EditProjectPageProps) {
  return (
    <Container>
      <EditProjectForm
        project={project}
        users={users}
        charity={charity}
      />
    </Container>
  );
}

EditProjectPage.layout = (page: ReactNode) => <Layout><ProjectLayout>{page}</ProjectLayout></Layout>;
